var exports = {
  "container": "x1cb7f6e3--e8990a--container",
  "content-wrapper": "x1cb7f6e3--e8990a--content-wrapper",
  "phone": "x1cb7f6e3--e8990a--phone",
  "button-wrapper": "x1cb7f6e3--e8990a--button-wrapper",
};

module.exports = exports;
